import { Box, Text } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

import FeatureItem from './_FeatureItem'

interface BenefitsLandingFooterProps {
  content: {
    cta: {
      title: string
      buttonText: string
    }
    features: Array<{
      title: string
      subtitle: string
    }>
  }
}

const BenefitsLandingFooter = ({ content }: BenefitsLandingFooterProps) => {
  return (
    <Box style={{ maxWidth: '1040px', margin: '0 auto', paddingBottom: '80px' }}>
      <Box
        alignItems="center"
        textAlign="center"
        gap="s24"
        padding="s48"
        className="relative overflow-hidden rounded-lg h-[450px]"
      >
        <video
          src="https://stream.mux.com/r39cDjjeCTL02LISNb1NhOsp02Aq7wL01bg/high.mp4" // in-app-footer.mp4
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            minHeight: '450px',
            width: '100%',
            height: '450px',
            objectFit: 'cover',
            zIndex: -2,
          }}
          autoPlay
          muted
          loop
        />
        <Box
          style={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            zIndex: '-1',
          }}
        />
        <Text size="700" weight="bold" color="white" className="max-w-[600px] py-12">
          {content.cta.title}
        </Text>
      </Box>
      <Box
        paddingTop="s48"
        textAlign="center"
        gap="s48"
        className="flex-col md:flex-row md:items-start justify-center"
      >
        {content.features.map((feature, index) => (
          <FeatureItem key={index} feature={feature} />
        ))}
      </Box>
      <Box className="flex justify-center w-[200px] mx-auto py-12">
        <UpsellingKit.UpsellButton
          label={content.cta.buttonText}
          requestSource="benefits-landing"
          pageSource="benefits-landing"
          requestReason={ValidReasons.MissingAddon}
          moduleRequested={AvailableModules.benefits}
          featureRequested={Features.benefits_core}
        />
      </Box>
    </Box>
  )
}

export default BenefitsLandingFooter
